module.exports = __webpack_public_path__ + "front/img/bg02.f6c7e9c5.png";